import { render, staticRenderFns } from "./Contractor.vue?vue&type=template&id=16564f7d&scoped=true&"
import script from "./Contractor.vue?vue&type=script&lang=js&"
export * from "./Contractor.vue?vue&type=script&lang=js&"
import style0 from "./Contractor.vue?vue&type=style&index=0&id=16564f7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16564f7d",
  null
  
)

export default component.exports